import React, { Component } from "react";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

export default class Snackbar1 extends Component {
  render() {
    const { open, close_snack_bar, message, loading, result } = this.props;
console.log(this.props);

    return (
      <div>
        {/* Loader positioned at the top of the page */}
        {loading && (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              zIndex: 1000,
              backgroundColor: result ? "green" : "red",
              padding: "10px 0",
            }}
          >
            <CircularProgress
              color="inherit"
              style={{ color: result ? "white" : "black" }} // Set loader color
            />
          </Box>
        )}

        <Snackbar
          anchorOrigin={{
            vertical: "center",
            horizontal: "center",
          }}
          open={open}
          autoHideDuration={2000}
          onClose={close_snack_bar}
          ContentProps={{
            "aria-describedby": "message-id",
            style: {
              backgroundColor: result ? "green" : "red",
            },
          }}
          message={<span id="message-id">{message}</span>}
          action={[
            <IconButton
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={close_snack_bar}
            >
              <Icon>close</Icon>
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}
